import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Logo } from "@/components/Logo";
import { toast } from "sonner";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("Şifreler eslemiyor");
    if (pw.length < 6) return toast.error("Şifre en az 6 karakter olmalı");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Şifreniz sıfırlandı. Yeni şifrenizle giriş yapabilirsiniz.");
      nav("/giris");
    } catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-8">
      <form onSubmit={submit} className="bg-white border border-gray-100 rounded-lg p-8 shadow-sm w-full max-w-md">
        <div className="flex justify-center mb-5"><Logo size="lg" /></div>
        <h1 className="text-2xl font-black text-center mb-1">Yeni Şifre Belirle</h1>
        <p className="text-sm text-gray-500 text-center mb-6">Lütfen yeni şifrenizi girin</p>
        {!token && <div className="bg-red-50 border border-red-200 text-red-700 rounded p-3 text-sm mb-4">Geçersiz veya eksik token. Lütfen mailınızdaki bağlantıyı kullanın.</div>}
        <label className="block text-sm font-medium mb-1">Yeni Şifre</label>
        <input type="password" required value={pw} onChange={(e) => setPw(e.target.value)} className="w-full px-3 py-2 border border-gray-200 rounded-md text-sm mb-3" />
        <label className="block text-sm font-medium mb-1">Şifreyi Tekrarla</label>
        <input type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} className="w-full px-3 py-2 border border-gray-200 rounded-md text-sm mb-4" />
        <button type="submit" disabled={loading || !token} className="w-full px-4 py-2.5 bg-[#e11d2a] text-white rounded-md font-semibold disabled:opacity-50">{loading ? "Sıfırlanıyor..." : "Şifreyi Sıfırla"}</button>
        <div className="mt-4 text-sm text-center"><Link to="/giris" className="text-[#e11d2a] font-semibold">Girişe dön</Link></div>
      </form>
    </div>
  );
}
